import {AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Table} from 'primeng/table';
import {TableColumnDef} from '../../../../../../shared/tables/table-column-def';
import {FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {GeneralService, SnackbarService} from '../../../../../../core/services';
import {FilterOutputModel, TableResponseQuery} from '../../../../../../core/models';
import {Observable, of} from 'rxjs';
import {ProductLogicsBrowserList, ProductLogicsMainDependenciesList} from '../../../../model/model';

@Component({
    selector: 'pr-product-logics-modal-browser-new',
    templateUrl: './product-logics-modal-browser-new.component.html',
    styleUrls: ['./product-logics-modal-browser-new.component.scss',  '../../../../../../components/new-table/base-table.scss']
})
export class ProductLogicsModalBrowserNewComponent implements OnInit, AfterViewInit {

    @HostBinding('class') classes = 'flex flex-grow';

    @ViewChild('dt', {static: false}) dt: Table;

    @ViewChild('tableWrapper', {static: false}) tableWrapper: ElementRef;

    @Input() columnsData: Array<TableColumnDef>;
    @Input() dataService: any;
    @Input() sortBy: string;
    @Input() dataServiceMethod = 'fetchData';
    @Input() selectedData: any[] = [];
    @Input() title: string;
    @Input() tableId: string;
    @Input() originProducts: ProductLogicsMainDependenciesList[] = [];

    @Input()
    set customPageSize(value: number) {
        if (value === this.perPage) {
            return;
        }
        this.perPage = value;

        setTimeout(() => {
            this.loadData(this.dt.createLazyLoadMetadata());
        }, 100);
    }

    @Output()
    tableDataLoaded = new EventEmitter();

    @Output()
    tableCountLoaded = new EventEmitter();

    @Output()
    selectedRows = new EventEmitter();

    @Output() customPageSizeChange = new EventEmitter();

    perPage = 25;

    filterGlobalControl = new FormControl('');

    idFieldName: string;
    totalRecords = 0;
    tableData: any[] = [];
    isLoading = true;
    showTable = false;

    selected = [];

    columns: TableColumnDef[];

    private selectedField: TableColumnDef = {
        field: 'selectedField',
        columnDef: 'selectedField',
        header: 'Selected',
        showSort: false,
        showSearch: false,
        width: 10
    };

    private addField: TableColumnDef = {
        field: 'addField',
        columnDef: 'addField',
        header: '',
        showSort: false,
        showSearch: false,
        width: 10
    };

    constructor(
        private router: Router,
        public generalService: GeneralService,
        private snackBar: SnackbarService,
    ) {
    }

    ngOnInit(): void {
        const tmpColumns = [].concat(this.columnsData);
        this.idFieldName = tmpColumns.shift().columnDef;

        this.columns = [this.selectedField, ...tmpColumns, this.addField];

        this.tableId = 'Table_' + this.tableId;

    }

    ngAfterViewInit() {
        this.checkAllColumnIfExist();
        this.checkWidths();
    }

    onPage(event) {
        this.customPageSizeChange.emit(event.rows);
    }

    clearGlobalFilter() {
        this.filterGlobalControl.reset();
        this.dt.filterGlobal('', 'contains');
        this.loadData(this.dt.createLazyLoadMetadata());
    }

    loadData(event: any) {
        this.isLoading = true;

        let sort = this.sortBy;
        if (event.sortField !== undefined && event.sortField !== null) {
            const columnDef = this.columnsData.find(
                (c: TableColumnDef) => c.columnDef === event.sortField
            );
            sort = ((columnDef.sortColumnDef) ? columnDef.sortColumnDef : event.sortField) + (event.sortOrder === 1 ? ' asc' : ' desc');
        }

        let filters: FilterOutputModel[] = [];
        if (event.filters !== undefined && event.filters !== null) {
            filters = Object.keys(event.filters)
                .filter(e => e !== 'global')
                .map((e) =>
                    <FilterOutputModel>{
                        filterValues: [event.filters[e].value],
                        columnDef: this.columnsData.find(
                            (c: TableColumnDef) => c.columnDef === e
                        ),
                    }
                );
        }

        this.dataService[this.dataServiceMethod](
            this.perPage,
            event.first,
            sort,
            event.globalFilter,
            filters
        )
            .subscribe(
                (d: TableResponseQuery) => {
                    this.tableData = d.items;
                    this.totalRecords = d.total_count;
                    this.tableCountLoaded.emit(this.totalRecords);
                    this.tableDataLoaded.emit(this.tableData);
                },
                (error: any) => {
                    console.log('TableComponentError', error);
                    this.messageOnFetchData(error);
                    this.isLoading = false;
                },
                () => {
                    this.isLoading = false;
                }
            );
    }

    searchByColumn(col: TableColumnDef) {
        this.dt.filter(
            col.searchValue,
            col.field,
            'contains'
        );

        col.searched = true;
    }

    clearSearchByColumn(col: TableColumnDef) {
        col.searchValue = '';
        this.dt.filter(
            col.searchValue,
            col.field,
            'contains'
        );

        col.searched = false;
    }

    reloadTable() {
        this.loadData(this.dt.createLazyLoadMetadata());
    }

    addRow(row) {
        this.selectedRows.emit(row);
        this.selected = this.selected.filter((sel) => sel.Id !== row.Id);
    }

    getTooltip(column: Object, row: any): string {
        try {
            switch (column['type']) {
                case 'date':
                    return row ? this.generalService.parseDate(row) : row;
                    break;
                case 'vat':
                    return row
                        ? this.generalService.parseVAT(row).toFixed(0)
                        : row;
                    break;
                case 'margin':
                    return row
                        ? this.generalService.parseVAT(row).toFixed(1)
                        : row;
                default:
                    break;
            }
            switch (column['suffix']) {
                case 'currency':
                    return row ? row.toFixed(2) : row;
                    break;
                default:
                    return row;
                    break;
            }
        } catch (e) {
            console.log(e);
            console.log('error in type');
        }
    }

    hasBeenUsed(id: number) {
        return this.selectedData.find(
            (selected) => id === selected[this.idFieldName]
        )
            ? true
            : false;
    }

    addSelectedItems() {
        this.selected.forEach(selected => this.addRow(selected));
    }

    resetTable() {
        this.dt.clear();
        this.dt.clearState();
        this.showTable = false;

        setTimeout(() => {
            this.showTable = true;
        }, 0);
    }

    hasRelations(row: ProductLogicsBrowserList) {
        return !(
            (row.IsProductDependent || row.IsProductMain) &&
            !this.originProducts.find((product) => product.Id === row.Id)
        );
    }

    private messageOnFetchData(error): Observable<TableResponseQuery> {
        if (error.status !== 403) {
            this.snackBar.info('Wystąpił problem podczas pobierania danych.');
        }
        return of(new TableResponseQuery([], 0));
    }

    private checkAllColumnIfExist() {
        const tableSettings = JSON.parse(localStorage.getItem(this.tableId));

        if (tableSettings) {

            if (tableSettings.selection) {
                delete tableSettings.selection;
                localStorage.setItem(this.tableId, JSON.stringify({
                    ...tableSettings
                }));
            }

            const columnOrder: string[] = tableSettings.columnOrder;
            const columnsToRemoveIndex: number[] = [];

            const columnsToRemove: string[] = columnOrder.filter((columnName, index) => {
                if (!(!!this.columns.find(col => col.field === columnName))) {
                    columnsToRemoveIndex.push(index);
                    return true;
                }

                return false;
            });

            if (tableSettings.sortField && !(!!this.columnsData.find(col => col.field === tableSettings.sortField))) {
                delete tableSettings.sortField;
                delete tableSettings.sortOrder;

                localStorage.setItem(this.tableId, JSON.stringify({
                    ...tableSettings
                }));
            }

            if (tableSettings.filters && !(!!this.columnsData.find(col => col.field === Object.keys(tableSettings.filters)[0]))) {
                delete tableSettings.filters;

                localStorage.setItem(this.tableId, JSON.stringify({
                    ...tableSettings
                }));
            }

            if (columnsToRemove.length > 0) {
                const oldColumnsWidth = tableSettings.columnWidths.split(',');

                const newColumns = columnOrder.filter((col, index) => {
                    return columnsToRemoveIndex.indexOf(index) === -1;
                });

                const newColumnsWidths = oldColumnsWidth.filter((val, index) => {
                    return columnsToRemoveIndex.indexOf(index) === -1;
                });

                localStorage.setItem(this.tableId, JSON.stringify({
                    ...tableSettings,
                    columnWidths: newColumnsWidths.join(','),
                    columnOrder: newColumns
                }));
            }
        }
    }

    private checkWidths() {
        const tableSettings = JSON.parse(localStorage.getItem(this.tableId));

        if (tableSettings && this.tableWrapper) {
            // setTimeout(() => {
            const tableWidth = this.tableWrapper.nativeElement.offsetWidth;
            const oldColumnsWidth = tableSettings.columnWidths.split(',');
            const columnWidth = oldColumnsWidth.reduce((a, b) => a + parseInt(b), 0);

            if (tableWidth < columnWidth) {
                const totalLengthToCut = columnWidth - tableWidth + 40;

                const newColumnsWidth = oldColumnsWidth.map((val: string) => {
                    const percentColumn = Math.round((parseInt(val) * 100) / columnWidth);
                    const lengthToCut = Math.round((totalLengthToCut * percentColumn) / 100);
                    return (parseInt(val) - lengthToCut);
                });

                localStorage.setItem(this.tableId, JSON.stringify({
                    ...tableSettings,
                    columnWidths: newColumnsWidth.join(',')
                }));
            }
        }

        setTimeout(() => {
            this.showTable = true;
        }, 0);
    }
}
